import { diff_match_patch } from "../vendor/diff_match_patch"

type Change =
  | { type: "insert"; idx: number; length: number; str: string }
  | { type: "delete"; idx: number; length: number; str: undefined }

export type Diff = Change[]

class Differ {
  diff(original: string, changed: string): Diff {
    const dmp = new diff_match_patch()
    const diffList = dmp.diff_main(original, changed)
    return this.compactDiff(diffList)
  }

  compactDiff(diff: any[]): Diff {
    const { result }: { result: Diff } = diff.reduce(
      ({ result, idx }, d): { result: Diff; idx: number } => {
        const diffType = d[0]
        const str = d[1]
        switch (diffType) {
          case 0:
            return { result, idx: idx + str.length }
          case 1:
            return {
              result: [
                { type: "insert", idx, str, length: str.length } as Change,
                ...result,
              ],
              idx,
            }
          case -1:
            return {
              result: [
                { type: "delete", idx, length: str.length } as Change,
                ...result,
              ],
              idx: idx + str.length,
            }
          default:
            throw new Error("Invalid diff type")
        }
      },
      { result: [], idx: 0 }
    )
    return result
  }

  apply(original: string, diff: Diff): string {
    const { result } = diff.reduce(
      ({ result, offset }, { type, idx, str, length }) => {
        const index = idx + offset
        const left = index === 0 ? "" : result.slice(0, index)
        const right = result.slice(index)

        if (type === "insert") {
          return {
            result: left + str + right,
            offset: offset + str.length,
          }
        } else if (type === "delete") {
          const updatedRight = length
          return {
            result: left + updatedRight,
            offset: offset - length,
          }
        } else {
          throw new Error("Invalid diff operation")
        }
      },
      { result: original, offset: 0 }
    )
    return result
  }
}

export { Differ }
